import "./wohnungen.29f7fa0b.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb9fb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb9fb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $47Sz1 = parcelRequire("47Sz1");

var $lfnQH = parcelRequire("lfnQH");

const $d5f8115d749cc683$var$lightbox1 = new (0, $47Sz1.default)({
    gallery: '#wohnung-1',
    children: 'a',
    preloadFirstSlide: true,
    pswpModule: (0, $lfnQH.default)
});
const $d5f8115d749cc683$var$lightbox2 = new (0, $47Sz1.default)({
    gallery: '#wohnung-2',
    children: 'a',
    preloadFirstSlide: true,
    pswpModule: (0, $lfnQH.default)
});
const $d5f8115d749cc683$var$lightbox3 = new (0, $47Sz1.default)({
    gallery: '#wohnung-3',
    children: 'a',
    preloadFirstSlide: true,
    pswpModule: (0, $lfnQH.default)
});
$d5f8115d749cc683$var$lightbox1.init();
$d5f8115d749cc683$var$lightbox2.init();
$d5f8115d749cc683$var$lightbox3.init();


//# sourceMappingURL=wohnungen.76e7ecdd.js.map
